<template>
    <div class="position-relative">
        <slot></slot>
        <div v-show="open" class="position-absolute card card-div w-95"
             :class="cardClass"
             tabindex="-1"
             @mousedown="eventPrevent">
            <slot name="card"></slot>
        </div>
        <slot name="outer"></slot>
    </div>
</template>

<script>
export default {
    name: "OpenCard",
    props: {
        cardClass: String,
        open: Boolean,
        preventDefault: Boolean,
    },
    methods: {
        eventPrevent(event) {
            if (this.preventDefault) {
                event.preventDefault();
            }
        },
    }
}
</script>

<style scoped>
.card-div {
    top: 100%;
    left: 0;
    height: min-content;
    width: max-content;
    z-index: 1000;
    background-color: #FFFFFF;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>
